
import { RevSkeleton } from '@backmarket/design-system'

export default {
  components: {
    RevSkeleton,
  },
}
